import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'
import { Element } from 'react-scroll'

import PartsSection from 'containers/Admin/PartsLibrary/Card'
import styles from './styles.scss'

class MainPanel extends Component {
  render() {
    const { parts, postParts, isLoading } = this.props
    const elements = parts && Object.keys(parts).map((part, index) => {
      return (
        <Element key={index} name={part}>
          <PartsSection 
            partName={part}
            partData={parts[part]}
            postParts={postParts}
          />
        </Element>
      )
    })

    return (
      <Flex id='scrollContainer' column auto styleName='mainPanel'>
        {!isLoading && elements}
      </Flex>
    )
  }
}

export default CSSModules(MainPanel, styles)
